<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <div>
              <h6>
                翻譯管理 ({{ currentLanguage ? currentLanguage.name : "..." }})
              </h6>
              <p class="text-xs mb-0" v-if="currentLanguage">
                code: {{ currentLanguage.code }}
              </p>
            </div>
            <div class="d-flex gap-2">
              <button
                class="btn btn-secondary btn-sm mb-0 me-2"
                @click="$router.push('/system/languages')"
              >
                返回
              </button>
              <button class="btn btn-info btn-sm mb-0" @click="openImportModal">
                匯入 JSON
              </button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <!-- Filter -->
            <div class="p-3 bg-gray-100 mb-3 mx-3 rounded">
              <div class="row">
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model="filters.search"
                    placeholder="搜尋 Key 或 Value"
                    @keyup.enter="fetchTranslations"
                  />
                </div>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="filters.group"
                    placeholder="Group (default)"
                    @keyup.enter="fetchTranslations"
                  />
                </div>
                <div class="col-md-2">
                  <button
                    class="btn btn-outline-primary w-100"
                    @click="fetchTranslations"
                  >
                    搜尋
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Group
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Key
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Value
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in translations"
                    :key="item.id || item.tempId"
                  >
                    <td>
                      <p class="text-xs font-weight-bold mb-0 px-3">
                        {{ item.group }}
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0 px-3">
                        {{ item.key }}
                      </p>
                    </td>
                    <td>
                      <div class="px-3">
                        <textarea
                          class="form-control"
                          rows="1"
                          v-model="item.value"
                          @change="markDirty(item)"
                          style="min-width: 300px"
                        ></textarea>
                      </div>
                    </td>
                    <td class="align-middle">
                      <button
                        v-if="item.isDirty"
                        class="btn btn-success btn-xs mb-0 me-2"
                        @click="saveTranslation(item)"
                      >
                        儲存
                      </button>
                    </td>
                  </tr>
                  <tr v-if="translations.length === 0">
                    <td colspan="4" class="text-center py-4">無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div
              class="p-3 d-flex justify-content-end"
              v-if="pagination.total > 0"
            >
              <nav aria-label="Page navigation">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: pagination.current_page === 1 }"
                  >
                    <a
                      class="page-link"
                      href="javascript:;"
                      @click="changePage(pagination.current_page - 1)"
                      >Previous</a
                    >
                  </li>
                  <li class="page-item active">
                    <span class="page-link">{{ pagination.current_page }}</span>
                  </li>
                  <li
                    class="page-item"
                    :class="{
                      disabled:
                        pagination.current_page === pagination.last_page,
                    }"
                  >
                    <a
                      class="page-link"
                      href="javascript:;"
                      @click="changePage(pagination.current_page + 1)"
                      >Next</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Import -->
    <div
      class="modal fade"
      id="importModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">匯入 JSON</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeImportModalBtn"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-sm">
              請貼上 JSON 格式的翻譯資料 (Nested valid JSON). 重複的 Key
              將會被覆蓋。
            </p>
            <textarea
              class="form-control"
              v-model="importJson"
              rows="10"
              placeholder='{"cart": {"title": "Cart"}}'
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn bg-gradient-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn bg-gradient-primary"
              @click="submitImport"
            >
              匯入
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

export default {
  name: "Translations",
  data() {
    return {
      languageId: this.$route.params.languageId,
      currentLanguage: null,
      translations: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
      },
      filters: {
        search: "",
        group: "",
      },
      importModalInstance: null,
      importJson: "",
    };
  },
  methods: {
    async fetchLanguage() {
      try {
        const response = await request.get(`/api/admin/languages`);
        if (response.data && Array.isArray(response.data)) {
          this.currentLanguage = response.data.find(
            (l) => l.id == this.languageId
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchTranslations(page = 1) {
      try {
        const params = {
          page: page,
          language_id: this.languageId,
        };
        if (this.filters.search) params.search = this.filters.search;
        if (this.filters.group) params.group = this.filters.group;

        const response = await request.get("/api/admin/translations", {
          params: params,
        });

        // response.data is the pagination object
        const result = response.data;

        this.translations = result.data.map((t) => ({
          ...t,
          isDirty: false,
        }));
        this.pagination = {
          current_page: result.current_page,
          last_page: result.last_page,
          total: result.total,
        };
      } catch (error) {
        console.error(error);
      }
    },
    changePage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.fetchTranslations(page);
      }
    },
    markDirty(item) {
      item.isDirty = true;
    },
    async saveTranslation(item) {
      item.isDirty = false;
      try {
        await request.post("/api/admin/translations", {
          language_id: this.languageId,
          group: item.group,
          key: item.key,
          value: item.value,
        });
        // Swal.fire("Saved", "", "success"); // Too noisy
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        toast.fire({
          icon: "success",
          title: "已儲存",
        });
      } catch (error) {
        // eslint-disable-next-line require-atomic-updates
        item.isDirty = true;
        console.error(error);
        Swal.fire("Error", "儲存失敗", "error");
      }
    },

    openImportModal() {
      const el = document.getElementById("importModal");
      if (el) {
        this.importModalInstance = new Modal(el);
        this.importModalInstance.show();
      }
    },
    async submitImport() {
      if (!this.importJson) return;
      let data;
      try {
        data = JSON.parse(this.importJson);
      } catch (e) {
        Swal.fire("Error", "JSON 格式錯誤", "error");
        return;
      }

      try {
        await request.post("/api/admin/translations/batch", {
          language_id: this.languageId,
          translations: data,
        });

        document.getElementById("closeImportModalBtn").click();
        this.importJson = "";
        this.fetchTranslations(1);
        Swal.fire("Success", "匯入成功", "success");
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "匯入失敗", "error");
      }
    },
  },
  created() {
    this.fetchLanguage();
    this.fetchTranslations();
  },
};
</script>
